module.exports = __webpack_public_path__ + "media/images/emblems/Entlebuch_LU-e625545c7f7abe535d1ad54bebea61fa.png";